<script>

    import { onMount } from 'svelte'

    import PricesService from '../$services/prices.service'

    import InputText from './input.text.svelte'

    export let label = 'Etiqueta de precios'
    export let value = ''
    export let placeholder = 'precios_mayorista'

    export let required = false

    // avisa si la etiqueta aún no tiene precios: un error de dedo cae en silencio a precios públicos
    export let warn = false

    let tags = []

    $: normalized = (value || '').trim().toLowerCase().replace(/\s+/g, '_')
    $: unknown = warn && !!normalized && tags.indexOf(normalized) === -1

    onMount(async () => {

        const resp = await PricesService.getTags()

        if(resp && resp.success)
            tags = resp.data
    })

</script>

<InputText bind:value { label } { placeholder } { required } maxlength={50} />

{#if tags.length}
    <div class="tags">
        {#each tags as tag}
            <button type="button" class="tag is-light" class:is-info={tag === normalized} style="border: 0; cursor: pointer;" on:click={() => value = tag}>{ tag }</button>
        {/each}
    </div>
{/if}

{#if unknown}
    <p class="help is-warning mb-3">Aún no hay precios con esta etiqueta: se cotiza con precios públicos hasta que se creen.</p>
{/if}
